import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const NonPremiumNewsContent = ({ publicationName }) => (
  <div className={cx('nonPremiumNewsContainer')}>
    <div className={cx('nonPremiumNewsContent')}>
      <div className={cx('header')} />
      <div className={cx('bgcontent')} />
      <div className={cx('bgcontent-arrows')} />
      {publicationName ? (
        <div className={cx('content', { isPublication: publicationName })}>
          Select content from
          {' '}
          {publicationName}
          {' '}
          and
          {' '}
          <a href="https://help.cityfalcon.com/hc/en-us/articles/360034657073" target="_blank" rel="noreferrer">1000+ other publications</a>
          <br />
          without paywalls or advertising clutter.
        </div>
      ) : (
        <div className={cx('content')}>
          No paywalls and no advertisements for select content from &nbsp;
          <a href="https://help.cityfalcon.com/hc/en-us/articles/360034657073" target="_blank" rel="noreferrer">1000+ sources</a>
          .
        </div>
      )}
      <div className={cx('upgrade_button', 'gold')}>
        <Link
          rel="nofollow"
          to="/pricing"
        >
          Upgrade to GOLD
        </Link>
      </div>
      <div className={cx('footer')} />
    </div>
    <div className={cx('nonPremiumStoryCard')}>
      <div className={cx('nonPremiumStoryCard_Second')} />
      <div className={cx('nonPremiumStoryCard_Third')} />
      <div className={cx('nonPremiumStoryCard_First')}>
        <div className={cx('lineOne')} />
        <div className={cx('lineTwo')} />
      </div>
      <div className={cx('goldIcon__container')}>
        <div className={cx('goldIcon')}>
          <div className={cx('goldIcon__text')}>
            G
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default NonPremiumNewsContent;
